// Logo Option 2: Abstract wallet/budget icon with coin
import React from 'react';

const Logo2 = ({ className = "h-8 w-8" }) => {
 return (
 <svg
 viewBox="0 0 100 100"
 fill="none"
 xmlns="http://www.w3.org/2000/svg"
 className={className}
 style={{ color: 'hsl(var(--foreground))' }}
 >
 {/* Wallet body */}
 <rect
 x="20"
 y="35"
 width="60"
 height="45"
 rx="6"
 fill="hsl(213 94% 68%)"
 stroke="hsl(213 94% 68%)"
 strokeWidth="2"
 />

 {/* Wallet flap/top */}
 <path
 d="M20 35 L20 28 C20 25 22 23 25 23 L75 23 C78 23 80 25 80 28 L80 35"
 fill="hsl(213 94% 58%)"
 stroke="hsl(213 94% 58%)"
 strokeWidth="2"
 />

 {/* Card slot line */}
 <line
 x1="30"
 y1="45"
 x2="70"
 y2="45"
 stroke="currentColor"
 strokeWidth="2"
 strokeLinecap="round"
 opacity="0.6"
 />

 {/* Coin */}
 <circle
 cx="65"
 cy="60"
 r="15"
 fill="hsl(142 76% 36%)"
 stroke="hsl(142 76% 46%)"
 strokeWidth="2"
 />

 {/* Currency symbol on coin */}
 <text
 x="65"
 y="67"
 fontSize="16"
 fontWeight="bold"
 textAnchor="middle"
 fill="currentColor"
 fontFamily="Space Grotesk, sans-serif"
 >
 £
 </text>

 {/* Budget indicator bars */}
 <rect x="30" y="55" width="18" height="4" rx="2" fill="currentColor" opacity="0.7" />
 <rect x="30" y="62" width="12" height="4" rx="2" fill="currentColor" opacity="0.5" />
 <rect x="30" y="69" width="15" height="4" rx="2" fill="currentColor" opacity="0.6" />
 </svg>
 );
};

export default Logo2;
